export var SEARCH_CLEAR_ACTION_CLASS_PREFIX = 'SearchClearAction';
export var searchInputClearIcon = 'SearchInputClearIcon';